<template>
  <div>
    <alert ref="alert" ok-title="OK" :title="headerTitle">
      You can switch between your accounts from the profile menu.
    </alert>
    <alert-tooltip
      ref="alertTooltip"
      container-class="org-switch-tooltip"
      :heading="headerTitle"
      message="You can switch between your accounts from the profile menu."
      placement="right"
      target="profile-nav"
    />
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import AlertTooltip from '@/components/tooltip/AlertTooltip.vue'
import { ORG_SWITCH_QUERY_NAME } from '@/constants/common'
import { ROUTE_NAMES } from '@/constants/routes'
import FeaturesMixin from '@/mixins/FeaturesMixin'
import MediaQueryMixin from '@/mixins/MediaQueryMixin'
import convertStringToBoolean from '@/utils/convertStringToBoolean'
import * as R from 'ramda'

/**
 * Whenever user gets switched to a different subOrg,this shows an alert dialog.
 */
export default {
  name: 'SubOrgSwitchHandler',
  mixins: [FeaturesMixin, MediaQueryMixin],
  components: {
    AlertTooltip,
    Alert
  },
  computed: {
    isRootOrg() {
      return !this.subOrg || !this.subOrg.parentId
    },
    headerTitle() {
      let message = `Account switched to "${this.subOrg?.name}"`
      if (!this.isRootOrg) {
        message += ` within "${this.rootOrg?.name}" org`
      }
      return message
    },
    rootOrg() {
      return this.$store.getters.orgById(this.subOrg?.organizationId)
    },
    subOrgId() {
      return this.$store.getters['orgSelect/selectedOrgLikeTeamId']
    },
    subOrg() {
      return this.$store.getters.teamById(this.subOrgId)
    }
  },
  methods: {
    alert() {
      if (this.isDesktopMode) {
        this.$refs.alertTooltip.show()
      } else {
        this.$refs.alert.show()
      }
    },
    removeQuery() {
      this.$router.replace({
        ...this.$route,
        query: R.omit([ORG_SWITCH_QUERY_NAME], this.$route.query)
      })
    }
  },
  watch: {
    subOrgId(newId, oldId) {
      const isOrgSwitched = convertStringToBoolean(this.$route.query[ORG_SWITCH_QUERY_NAME])
      const routesToAlert = [
        ROUTE_NAMES.GOAL,
        ROUTE_NAMES.KR,
        ROUTE_NAMES.INITIATIVE,
        ROUTE_NAMES.PROJECT
      ]
      if (
        Number(newId) !== Number(oldId) &&
        (routesToAlert.includes(this.$route.name) || isOrgSwitched)
      ) {
        this.alert()
        if (isOrgSwitched) {
          this.removeQuery()
        }
      }
    }
  }
}
</script>

<style lang="scss">
.org-switch-tooltip {
  left: 10px !important;
}
</style>
